<template>
  <Transition name="peekaboo">
    <menu v-if="isVisible" class="navigation-top">
      <section class="navigation-top__container">
        <router-link to="/">
          <img src="/images/LogoMDA-EN.png" class="navigation-top__logo" alt=""/>
        </router-link>

        <ul class="navigation-top__list">
          <template v-for="entry in links">
            <a
              v-if="entry.external"
              :key="entry.label"
              :href="entry.link"
              target="_blank"
              rel="noopener noreferrer"
              class="navigation-top__item">
              {{ entry.label }}
            </a>

            <RouterLink
              v-else
              :key="entry.label"
              :to="{ hash: entry.hash }"
              class="navigation-top__item">
              {{ entry.label }}
            </RouterLink>
          </template>
        </ul>

        <div class="navigation-top__burger" @click="$emit('toggle-sidenav')">
          <svg-icon id="menu" />
        </div>
      </section>
    </menu>
  </Transition>
</template>

<script>
export default {
  name: 'NavigationTop',
  data() {
    return {
      isVisible: false
    }
  },
  computed: {
    links() {
      const menu = this.$i18n.t('menu')
      return menu.map(entry => {
        return entry.external 
          ? { external: true, label: entry.label, link: entry.link }
          : { external: false, label: this.$i18n.t(`menuLabels.${entry.hash}`), hash: `#${entry.hash}` }
      })
    }
  },
  watch: {
    '$device.laptop': {
      immediate: true,
      handler(isLaptop) {
        if (!isLaptop) this.isVisible = true
        else this.updateVisibility()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$scroll.on(this.updateVisibility)
    })
  },
  methods: {
    updateVisibility() {
      if (!this.$device.laptop) return

      const refNode = document.querySelector('[data-peekaboo]')
      if (!refNode) return

      this.isVisible = refNode.getBoundingClientRect().top < 72
    }
  }
}
</script>

<style lang="scss">
.peekaboo {
  &-enter-active,
  &-leave-active {
    transition: transform 240ms cubic-bezier(0.6, 0.05, 0.01, 0.99);
  }

  &-enter,
  &-leave-to {
    transform: translate3d(0, -100%, 0);
  }

  &-leave,
  &-enter-to {
    transform: translateZ(0);
  }
}
</style>
